import React from 'react'
import { Button } from '@chakra-ui/react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import { useUserPreferences } from '../../providers'

const PreviewToggleButton: React.FC = () => {
  const { prefs, setPreviewVisible } = useUserPreferences()
  const visible = prefs.previewVisible

  return (
    <Button
      onClick={() => void setPreviewVisible(!visible)}
      leftIcon={visible ? <FiEyeOff /> : <FiEye />}
      fontWeight="normal"
      width="auto"
      sx={{
        padding: '6px 8px',
        height: '33px',
        borderRadius: '4px',
        border: '1px solid #e1e4eb',
        backgroundColor: '#fff',
        color: '#4a5568',
      }}
    >
      {visible ? 'Hide Preview' : 'Preview'}
    </Button>
  )
}

export default PreviewToggleButton
